import LandingPage from "./Pages/LandingPage";
import Dashboard from "./Pages/Dashboard";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Contact from "./Pages/Contact";
import Docs from "./Pages/Docs";

function App() {
  return (
      <Router>
      <Routes>
          {/* <Route element={<PrivateRoute />}> */}
            <Route path="/dashboard" element={<Dashboard/>} />            
          {/* </Route> */}
          {/* <Route element={<PublicRoute/>}> */}
            <Route path="/" element={<LandingPage/>} />
            <Route path="/contactus" element={<Contact/>} />
            <Route path="/docs/emailspam" element={<Docs/>} />
          {/* </Route> */}
      </Routes>
    </Router>
  );
}

export default App;
